import { useTranslation } from "next-i18next";
import { Typography, TypographyProps } from "src/components-mui/base/typography/typography";
import { useNumberFormatter } from "src/hooks/formatters/use-number-formatter";

interface ISearchResultCountProps extends TypographyProps {
    resultCount: number | null;
}

export const SearchResultCount = ({ resultCount, ...typographyProps }: ISearchResultCountProps) => {
    const { t } = useTranslation("extended-search");
    const { formatNumber } = useNumberFormatter();

    const displayedResultsCount = resultCount !== null ? formatNumber(resultCount) : "-";

    return (
        <Typography
            {...typographyProps}
            sx={[
                {
                    fontSize: "sm",
                },
                ...(Array.isArray(typographyProps.sx) ? typographyProps.sx : [typographyProps.sx]),
            ]}
        >
            <Typography
                component="strong"
                sx={{
                    fontSize: "xl",
                    fontWeight: "bold",
                    mr: 0.5,
                }}
            >
                {displayedResultsCount}
            </Typography>
            {t("wikifolios-found", { count: resultCount ?? 0 })}
        </Typography>
    );
};
